import React, {Component} from 'react';
import {connect} from 'react-redux';

import {throttle} from 'imatic/vsem-design/assets/util/Animation';

import {withAuth} from '../util/Auth';
import EventStream from '../../../public/js/components/EventStream/EventStream';

import styles from './ThreadStream.module.css';
import {threadEventsLoad} from '../../redux/actions';
import {getCurrentThread} from '../../redux/selectors';

class ThreadStream extends Component {

    constructor(props) {
        super(props);

        this.willFollowScroll = false;
        
        this.loadPrev = this.loadPrev.bind(this);
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentWillUpdate(next) {
        const prev = this.props;

        if (prev.events.size !== next.events.size) {
            this.reconsiderScroll();
        }
    }

    componentDidUpdate() {
        if (this.willFollowScroll) {
            this.scrollToBottom();

            this.willFollowScroll = false;
        }
    }

    loadPrev() {
        this.props.loadPreviousEvents(this.props.events.first().id);
    }

    render() {
        const {events, thread, currentParticipant, hasPrev, attributes} = this.props;

        return (
            <div className={styles.threadStream}>
                <div className={styles.streamContent}
                     ref={(container) => this.container = container}
                >
                    <EventStream events={events}
                                 attributes={attributes}
                                 hasPrev={hasPrev}
                                 thread={thread}
                                 currentParticipant={currentParticipant}
                                 loadPrev={this.loadPrev}
                    />
                </div>
            </div>
        );
    }

    reconsiderScroll() {
        if (this.isScrolledToBottom()) {
            this.willFollowScroll = true;
        }
    }

    isScrolledToBottom() {
        return this.container.scrollTop >= (this.container.scrollHeight - this.container.clientHeight);
    }

    scrollToBottom() {
        this.container.scrollTop = this.container.scrollHeight;
    }
}

export default withAuth(connect(
    (state) => {
        const thread = getCurrentThread(state);
        const threadType = state.getIn(['threadTypes', thread.threadType]);

        return {
            events: state.get('shownThreadEvents').map((id) => state.getIn(['threadEvents', id])),
            thread: thread.set('threadType', threadType),
            hasPrev: state.getIn(['shownThreadEventsMeta', 'hasPrev']),
            attributes: thread.attributes.map((id) => state.getIn(['threadAttributeValues', id]))
        };
    },
    (dispatch, props) => ({
        loadPreviousEvents(from) {
            return dispatch(threadEventsLoad(from, 'prev'));
        },
    }),
)(ThreadStream));
